import { render, staticRenderFns } from "./AlMenuSimple.vue?vue&type=template&id=e332c4f2&"
import script from "./AlMenuSimple.vue?vue&type=script&lang=js&"
export * from "./AlMenuSimple.vue?vue&type=script&lang=js&"
import style0 from "./AlMenuSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports